var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        width: "600px",
        title: _vm.title,
        visible: _vm.dialogVisible,
        "split-line": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.onClose,
        closed: _vm.onClosed,
      },
    },
    [
      _vm.data
        ? _c(
            "el-form",
            { attrs: { "label-width": "190px" } },
            [
              _vm.data.FromAnzo
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "Content Category" } },
                      [_c("span", [_vm._v(_vm._s(_vm.data.CategoryName))])]
                    ),
                    _c("el-form-item", { attrs: { label: "Short Title" } }, [
                      _c("span", [_vm._v(_vm._s(_vm.data.ShortTitle))]),
                    ]),
                    _c("el-form-item", { attrs: { label: "Search Term" } }, [
                      _c("span", [_vm._v(_vm._s(_vm.data.SearchTerm))]),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Allow Full Article Request" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.data.FullPaperRequest === 1 ? "Yes" : "No"
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c("el-form-item", { attrs: { label: "Any Comments" } }, [
                      _c(
                        "div",
                        {
                          ref: "commentWrapper",
                          staticClass: "any-comments-wrapper",
                        },
                        [_vm._v(" " + _vm._s(_vm.data.AnyComments) + " ")]
                      ),
                    ]),
                  ]
                : [
                    _c(
                      "el-form-item",
                      { attrs: { label: "Content Category" } },
                      [_c("span", [_vm._v(_vm._s(_vm.data.CategoryName))])]
                    ),
                    _c("el-form-item", { attrs: { label: "Content Title" } }, [
                      _c("span", [_vm._v(_vm._s(_vm.data.DocumentTitle))]),
                    ]),
                    _c("el-form-item", { attrs: { label: "Search Term" } }, [
                      _c("span", [_vm._v(_vm._s(_vm.data.SearchTerm))]),
                    ]),
                    _c("el-form-item", { attrs: { label: "Security Level" } }, [
                      _c("span", [_vm._v(_vm._s(_vm.data.levelName))]),
                    ]),
                    _c("el-form-item", { attrs: { label: "PDF Attached" } }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.data.AttachmentPath,
                            target: "blank",
                          },
                        },
                        [_vm._v(_vm._s(_vm.data.FileName))]
                      ),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Allow Full Article Request" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.data.FullPaperRequest === 1 ? "Yes" : "No"
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "content-container",
                        attrs: { label: "Content" },
                      },
                      [
                        _c("div", {
                          ref: "contentWrapper",
                          staticClass: "content-wrapper",
                          domProps: {
                            innerHTML: _vm._s(_vm.data.PaperContent),
                          },
                        }),
                      ]
                    ),
                  ],
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }